import React from "react";
import { Card, Typography, Tag, Space, Tooltip } from "antd";
import {
  EyeOutlined,
  CopyOutlined,
  DeleteOutlined,
  EditFilled,
} from "@ant-design/icons";
import { formatToIST } from "../../../helper/CommonHelper";
import { useNavigate } from "react-router-dom";

const { Text, Title } = Typography;

function EmailTemplateCard({ data, onDelete, onPreview, onCopy }) {
  const navigate = useNavigate();
  return (
    <Card
      hoverable
      style={{
        borderRadius: 16,
        height: "100%",
      }}
      bodyStyle={{ padding: 18 }}
    >
      {/* Header */}
      <Space
        align="start"
        style={{ width: "100%", justifyContent: "space-between" }}
      >
        <div>
          <Title level={5} style={{ marginBottom: 4 }}>
            {data?.name}
          </Title>
        </div>

        {/* <Space>
          <Tag color="green">easy</Tag>
          <Tag>IT</Tag>
        </Space> */}
      </Space>

      {/* Subject */}
      <Text type="secondary">
        <b>Subject:</b> {data?.subject}
      </Text>

      {/* Description */}
      {/* <div style={{ marginTop: 8 }}>
        <Text type="secondary">
          {data?.short_description ||
            "Your password has expired. Click here to reset immediately."}
        </Text>
      </div> */}

      {/* Divider */}
      <div
        style={{
          margin: "14px 0",
          height: 1,
          background: "#e5e7eb",
        }}
      />

      {/* Footer */}
      <Space
        style={{
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        <Text type="secondary">
          {formatToIST(data?.created_at) || "3/17/2026"}
        </Text>

        <Space size="middle">

           <Tooltip title="Edit">
            <EditFilled
              style={{ color: "#8c3add", cursor: "pointer" }}
              onClick={() => navigate("/edit-email/" + btoa(data.id))}
            />
          </Tooltip>

          <Tooltip title="Preview">
            <EyeOutlined
              style={{ color: "#8c3add", cursor: "pointer" }}
              onClick={() => onPreview(data.id)}
            />
          </Tooltip>

          <Tooltip title="Copy">
            <CopyOutlined
              style={{ cursor: "pointer" }}
              onClick={() => onCopy(data.id)}
            />
          </Tooltip>

          <Tooltip title="Delete">
            <DeleteOutlined
              style={{ color: "red", cursor: "pointer" }}
              onClick={() => onDelete(data.id)}
            />
          </Tooltip>
        </Space>
      </Space>
    </Card>
  );
}

export default EmailTemplateCard;